import * as api from "./apis/signup";
import { setTokens } from "./setTokens";
import { emit, triggerError } from "../utils/eventManager";
import { sendNewRelicEvent } from "../utils/newRelicEvents";
import { MfaRequiredError } from "../utils/GqlError";
export { signup };
async function signup(creds, profile, client) {
  try {
    sendNewRelicEvent({
      EventName: 'signup_start'
    });
    var signUpResponse = await api.signup(creds, profile, client);
    var tokens = signUpResponse.tokens,
      encryptedEmail = signUpResponse.encryptedEmail,
      encryptedCheggId = signUpResponse.encryptedCheggId,
      uuid = signUpResponse.uuid;
    var idToken = tokens.idToken,
      accessToken = tokens.accessToken;
    sendNewRelicEvent({
      EventName: 'signup_success'
    });
    emit('signup.success', {
      tokens: tokens,
      encryptedEmail: encryptedEmail,
      encryptedCheggId: encryptedCheggId,
      uuid: uuid
    });
    await setTokens({
      idToken: idToken,
      accessToken: accessToken,
      callInitSession: true,
      broadcast: true,
      authActionType: 'signup'
    });
    return signUpResponse;
  } catch (e) {
    if (e instanceof MfaRequiredError) {
      throw e;
    }
    sendNewRelicEvent({
      EventName: 'signup_failed',
      error: e
    });
    triggerError('signup', e);
    throw e;
  }
}